var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24AFB5",
    fillRule: "evenodd",
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.552 23.172h14.896a4.966 4.966 0 0 1 4.966 4.966v4.965a4.966 4.966 0 0 1-4.966 4.966H16.552a4.966 4.966 0 0 1-4.966-4.966v-4.965a4.966 4.966 0 0 1 4.966-4.966Z",
    clipRule: "evenodd",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.552 16.552h14.896a4.966 4.966 0 0 1 4.966 4.965v4.966a4.966 4.966 0 0 1-4.966 4.965H16.552a4.966 4.966 0 0 1-4.966-4.965v-4.966a4.966 4.966 0 0 1 4.966-4.965Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.552 9.931h14.896a4.965 4.965 0 0 1 4.966 4.966v4.965a4.966 4.966 0 0 1-4.966 4.966H16.552a4.966 4.966 0 0 1-4.966-4.966v-4.965a4.966 4.966 0 0 1 4.966-4.966Z",
    clipRule: "evenodd",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.1349bdd81acb7a3de65842147b658246.svg";
export { ForwardRef as ReactComponent };